// Orden del detalle en "Traslados — Multi Clasificador (Ampliado)".
//
// El detalle mezcla dos cosas: los artículos que SÍ se trasladan y los que se
// quedan con saldo en la bodega origen (cantidad 0). Para que el usuario pueda
// decidir, cada tipo del clasificador principal (p.ej. la referencia 111213)
// tiene que verse como un bloque: primero lo que sale, después lo que se queda.

export function ordenarDetalleConSaldo(detalle, idxPrincipal) {
  if (idxPrincipal == null) return detalle;
  const campo = `nombre_tipo_${idxPrincipal}`;
  return [...detalle].sort((a, b) => {
    const ta = a[campo], tb = b[campo];
    // Los artículos sin tipo del principal no forman bloque: van al final.
    if (ta == null && tb != null) return 1;
    if (tb == null && ta != null) return -1;
    if (ta != null && tb != null && ta !== tb) return String(ta).localeCompare(String(tb));
    if (!!a.en_traslado !== !!b.en_traslado) return a.en_traslado ? -1 : 1;
    return String(a.id_articulo).localeCompare(String(b.id_articulo));
  });
}
